"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const employee_service_1 = require("./employee.service");
const create_employee_dto_1 = require("./dto/create-employee.dto");
const update_employee_dto_1 = require("./dto/update-employee.dto");
const get_empolyees_query_dto_1 = require("./dto/get-empolyees-query.dto");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const employee_swagger_1 = require("./employee.swagger");
const reset_password_dto_1 = require("./dto/reset-password.dto");
const enum_1 = require("../../../../../../libs/service-lib/src/lib/enum");
let EmployeeController = class EmployeeController {
    constructor(employeeService) {
        this.employeeService = employeeService;
    }
    /**
     * Retrieve a list of Employee records for the dropdown by delegating the employee service.
     */
    async getEmployeesListOfValues(res, queries) {
        try {
            const employees = await this.employeeService.getListOfEmployeesValues(queries?.sort, queries?.search, queries?.searchBy, queries?.page ?? constants_1.DEFAULT_EMPLOYEE_PAGE, queries?.limit ?? constants_1.DEFAULT_EMPLOYEE_PAGE_LIMIT);
            return res.status(enum_1.statusCode.ok).json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.employeeListRetrieval, {
                data: employees.data,
                count: employees.count,
            }));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    /**
     * Create a new Employee record by delegating the employee service.
     */
    async addEmployee(createEmployeeObject, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid) ?? constants_1.DEFAULT_EMPLOYEE_CREATED_BY;
            const employee = await this.employeeService.addEmployee(createEmployeeObject, userId);
            if (employee) {
                await this.employeeService.sendPasswordResetMail(employee.emailId, employee.userId);
            }
            return res
                .status(enum_1.statusCode.created)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.CREATED, messages_1.successMessage.employeeCreation, employee));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    /**
     * Validate password reset token
     */
    async validateResetToken(token, res) {
        try {
            await this.employeeService.validateResetToken(token);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.employeeRetrieval));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    /**
     * Reset password using token
     */
    async resetPassword(body, res) {
        try {
            await this.employeeService.resetPassword(body.token, body.password);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.passwordUpdated));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    /**
     * Send password reset mail for an employee.
     */
    async sendPasswordResetMail(emailId, res) {
        try {
            const employee = await this.employeeService.getEmployeeByEmailId(emailId);
            await this.employeeService.sendPasswordResetMail(employee.emailId, employee.userId, employee.firstName);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.passwordResetMailSent));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    /**
     * Retrieve all Employee records by delegating the employee service.
     */
    async getEmployees(res, queries) {
        try {
            const employees = await this.employeeService.getEmployees(queries?.sort, queries?.search, queries?.searchBy, queries?.page ?? constants_1.DEFAULT_EMPLOYEE_PAGE, queries?.limit ?? constants_1.DEFAULT_EMPLOYEE_PAGE_LIMIT);
            return res.status(enum_1.statusCode.ok).json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.employeeListRetrieval, {
                data: employees.data,
                count: employees.count,
            }));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    /**
     * Retrieve employee hierarchy for a given root userId.
     */
    async getEmployeeHierarchy(res, req, userId) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const hierarchy = await this.employeeService.getEmployeeHierarchyByUserId(+userId);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.employeeHierarchyRetrieval, hierarchy));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    /**
     * Retrieve employee hierarchy for a given root userId.
     */
    async getEmployeeParentWithPrivilege(res, userId, aclCategoryKey, aclActionKey) {
        try {
            if (!aclCategoryKey || !aclActionKey) {
                throw new common_1.BadRequestException(messages_1.infoMessages.missingPrivilegeKeys);
            }
            const parent = await this.employeeService.getParentUserWithPrivilege(+userId, aclCategoryKey, aclActionKey);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.parentWithPrivilege, parent));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    /**
     * Retrieve users with a given privilege.
     */
    async getUsersWithPrivilege(res, aclCategoryKey, aclActionKey, limit, page) {
        try {
            if (!aclCategoryKey || !aclActionKey) {
                throw new common_1.BadRequestException(messages_1.infoMessages.missingPrivilegeKeys);
            }
            if (page === undefined || isNaN(page) || page < 1) {
                page = constants_1.DEFAULT_EMPLOYEE_PAGE;
            }
            if (limit === undefined || isNaN(limit) || limit < 1) {
                limit = constants_1.DEFAULT_EMPLOYEE_PAGE_LIMIT;
            }
            const users = await this.employeeService.getAllUsersWithPrivilege(aclCategoryKey, aclActionKey, page, limit);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.employeesWithPrivilege, users));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    /**
     * Retrieve a single Employee record by ID by delegating the employee service.
     */
    async getEmployeeById(res, employeeId) {
        try {
            const employee = await this.employeeService.getEmployeeById(+employeeId);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.employeeRetrieval, employee));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    /**
     * Update an existing Employee record by ID by delegating the employee service.
     */
    async updateEmployeeById(res, req, employeeId, updateEmployeeObject) {
        const userId = parseInt(req?.headers?.userid) ?? constants_1.DEFAULT_EMPLOYEE_CREATED_BY;
        try {
            if (!updateEmployeeObject) {
                return res
                    .status(enum_1.statusCode.badRequest)
                    .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.infoMessages.employeeUpdateFailed));
            }
            const employee = await this.employeeService.updateEmployeeById(+employeeId, updateEmployeeObject, userId);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.employeeUpdate, employee));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    /**
     * Delete an Employee record by ID by delegating the employee service.
     */
    async deleteEmployeeById(res, employeeId, delegateId, newManagerId) {
        try {
            await this.employeeService.deleteEmployeeById(+employeeId, delegateId, newManagerId);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.employeeDeletion));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    /**
     * Triggers the rebuilding of the entire employee hierarchy.
     * This is a potentially long-running operation.
     */
    async rebuildHierarchy(res, req) {
        try {
            const creatorId = parseInt(req?.headers?.userid) || constants_1.DEFAULT_ADMIN_ID;
            await this.employeeService.rebuildFlatHierarchy(creatorId);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Employee hierarchy rebuild process initiated successfully."));
        }
        catch (error) {
            return this.handleErrorResponse(error, res);
        }
    }
    handleErrorResponse(error, res, notFoundMessage = messages_1.infoMessages.employeeNotFound, forbiddenMessage = messages_1.infoMessages.forBidden, badRequestMessage = messages_1.infoMessages.unknownError) {
        if (error instanceof common_1.NotFoundException) {
            return res
                .status(enum_1.statusCode.notFound)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.notFound, error.message || notFoundMessage));
        }
        else if (error instanceof common_1.ForbiddenException) {
            return res
                .status(enum_1.statusCode.forbidden)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.forbidden, error.message || forbiddenMessage));
        }
        else {
            return res
                .status(enum_1.statusCode.badRequest)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, error instanceof Error ? error.message : badRequestMessage));
        }
    }
};
exports.EmployeeController = EmployeeController;
tslib_1.__decorate([
    (0, common_1.Get)("list-of-values"),
    (0, employee_swagger_1.getListOfEmployeesValuesSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Query)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_b = typeof get_empolyees_query_dto_1.GetEmployeesDto !== "undefined" && get_empolyees_query_dto_1.GetEmployeesDto) === "function" ? _b : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "getEmployeesListOfValues", null);
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, employee_swagger_1.addEmployeeSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_c = typeof create_employee_dto_1.CreateEmployeeDto !== "undefined" && create_employee_dto_1.CreateEmployeeDto) === "function" ? _c : Object, Object, typeof (_d = typeof Request !== "undefined" && Request) === "function" ? _d : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "addEmployee", null);
tslib_1.__decorate([
    (0, common_1.Get)('password-reset/validate'),
    tslib_1.__param(0, (0, common_1.Query)('token')),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "validateResetToken", null);
tslib_1.__decorate([
    (0, common_1.Post)('password-reset'),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_e = typeof reset_password_dto_1.ResetPasswordDto !== "undefined" && reset_password_dto_1.ResetPasswordDto) === "function" ? _e : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "resetPassword", null);
tslib_1.__decorate([
    (0, common_1.Post)('password-reset-mail/:emailId'),
    tslib_1.__param(0, (0, common_1.Param)('emailId')),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "sendPasswordResetMail", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, employee_swagger_1.getEmployeesSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Query)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_f = typeof get_empolyees_query_dto_1.GetEmployeesDto !== "undefined" && get_empolyees_query_dto_1.GetEmployeesDto) === "function" ? _f : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "getEmployees", null);
tslib_1.__decorate([
    (0, common_1.Get)("/hierarchy"),
    (0, employee_swagger_1.getEmployeeHierarchySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Param)("userId")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_g = typeof Request !== "undefined" && Request) === "function" ? _g : Object, Number]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "getEmployeeHierarchy", null);
tslib_1.__decorate([
    (0, common_1.Get)(":userId/parentPrivilege"),
    (0, employee_swagger_1.getEmployeeHierarchySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Param)("userId")),
    tslib_1.__param(2, (0, common_1.Query)("aclCategoryKey")),
    tslib_1.__param(3, (0, common_1.Query)("aclActionKey")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Number, String, String]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "getEmployeeParentWithPrivilege", null);
tslib_1.__decorate([
    (0, common_1.Get)("privilege"),
    (0, employee_swagger_1.getEmployeeHierarchySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Query)("aclCategoryKey")),
    tslib_1.__param(2, (0, common_1.Query)("aclActionKey")),
    tslib_1.__param(3, (0, common_1.Query)("limit")),
    tslib_1.__param(4, (0, common_1.Query)("page")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, String, String, Number, Number]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "getUsersWithPrivilege", null);
tslib_1.__decorate([
    (0, common_1.Get)(":employeeId"),
    (0, employee_swagger_1.getEmployeeByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Param)("employeeId")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Number]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "getEmployeeById", null);
tslib_1.__decorate([
    (0, common_1.Put)(":employeeId"),
    (0, employee_swagger_1.updateEmployeeSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Param)("employeeId")),
    tslib_1.__param(3, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_h = typeof Request !== "undefined" && Request) === "function" ? _h : Object, Number, typeof (_j = typeof update_employee_dto_1.UpdateEmployeeDto !== "undefined" && update_employee_dto_1.UpdateEmployeeDto) === "function" ? _j : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "updateEmployeeById", null);
tslib_1.__decorate([
    (0, common_1.Delete)(":employeeId"),
    (0, employee_swagger_1.deleteEmployeeSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Param)("employeeId")),
    tslib_1.__param(2, (0, common_1.Query)("delegateId")),
    tslib_1.__param(3, (0, common_1.Query)("newManagerId")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Number, Number, Number]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "deleteEmployeeById", null);
tslib_1.__decorate([
    (0, common_1.Post)("rebuild-hierarchy"),
    (0, employee_swagger_1.rebuildHierarchySwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_k = typeof Request !== "undefined" && Request) === "function" ? _k : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], EmployeeController.prototype, "rebuildHierarchy", null);
exports.EmployeeController = EmployeeController = tslib_1.__decorate([
    (0, common_1.Controller)("employee"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof employee_service_1.EmployeeService !== "undefined" && employee_service_1.EmployeeService) === "function" ? _a : Object])
], EmployeeController);
